export default __webpack_public_path__ + "static/media/murderbasement2.a2a80e3c.jpeg";